import { useMutation } from "@tanstack/react-query";
import { api } from "../../lib/api";

export function useEverifyDeleteCompany() {
  return useMutation({
    mutationFn: async (companyId) => {
      const { data } = await api.delete(`/everifycompany/deletecompany/${companyId}`);
      return data;
    },
  });
}
